import React, {Component} from "react";
import ContingencyTrustBbvaView from "./CustodyTitlesView";
import {Button} from "primereact/button";
import {Growl} from "primereact/growl";
import {
    CUSTODY_TYPE_RECEIVE_ID,
    CUSTODY_TYPE_RECEIVE_LABEL,
    CUSTODY_TYPE_SEND_ID,
    CUSTODY_TYPE_SEND_LABEL,
    INSTRUCCION_CANCELADA_LABEL, INSTRUCCION_CREADA,
    INSTRUCCION_LIQUIDADA_LABEL, INSTRUCCION_NO_LIQUIDADA_LABEL,
    INSTRUCCION_MANUAL_LABEL
} from "../../../utils/constants/Constants";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {CustodyTitlesService} from "../../../service/operation/custodyTitles/CustodyTitlesService";
import NumberFormat from "react-number-format";

export default class CustodyTitlesContainer extends Component {
    constructor(props) {
        super(props);

        this.custodyTitlesService = new CustodyTitlesService();
        this.confirmationRef = null;
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        this.loading = this.loading.bind(this);
        this.getCatInstitution = this.getCatInstitution.bind(this);

        this.state = {
            isLoading: false,
            manualSettle: false,
            custodyInstructions: [],
            folioFilter: '',
            catLender: [],
            catBorrower: [],
            ptmFilter: [],
            pttFilter: [],
            catStatusFilter: {statusName: INSTRUCCION_NO_LIQUIDADA_LABEL},
            catInstructionTypeFilter: [],
            selectedInstruction: [],
            catInstructionType: [
                {
                    instructionId: CUSTODY_TYPE_RECEIVE_ID,
                    instructionName: CUSTODY_TYPE_RECEIVE_LABEL
                }, {
                    instructionId: CUSTODY_TYPE_SEND_ID,
                    instructionName: CUSTODY_TYPE_SEND_LABEL
                }
            ],
            catStatus: [
                {
                    statusName: INSTRUCCION_LIQUIDADA_LABEL
                }, {
                    statusName: INSTRUCCION_NO_LIQUIDADA_LABEL
                },{
                    statusName: INSTRUCCION_CANCELADA_LABEL
                },{
                    statusName: INSTRUCCION_MANUAL_LABEL
                }
            ],
            exportOptions: [
                {
                    label: "CSV", action: () => {
                        this.openConfirmationMessage("CSV")
                    }
                },
            ],
            typeDocument: '',
        };
        this.searchInstructionsCustody = this.searchInstructionsCustody.bind(this);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.exportSelection = this.exportSelection.bind(this);
        this.actionUpdateStatus = this.actionUpdateStatus.bind(this);
        this.actionsTemplate = this.actionsTemplate.bind(this);
        this.errorTemplate = this.errorTemplate.bind(this);
        this.openConfirmationMessage = this.openConfirmationMessage.bind(this);

        this.rewardBackGroundTemplate = this.rewardBackGroundTemplate.bind(this);
        this.rewardTitlesBody = this.rewardTitlesBody.bind(this);

        this.searchInstructionsCustody("FUNCTION");
        this.getCatInstitution();
    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    openConfirmationMessage(docType) {
        if (this.confirmationRef) {
            this.setState({
                typeDocument: docType,
            });
            this.confirmationRef.openConfirmationMessage();
        }
    }

    getCatInstitution() {
        this.loading();
        this.custodyTitlesService.getFilters().then(
            res => {
                if (res.success) {
                    this.setState({
                        catLender: res.payload.lenderDtoList,
                        catBorrower: res.payload.borrowerDtoList,
                    });
                } else {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: res.message
                    });
                }
            }
        );
    }

    searchInstructionsCustody(stringFlag) {
        this.loading();
        this.custodyTitlesService.geInstruction(
            this.state.folioFilter,
            this.state.ptmFilter,
            this.state.pttFilter,
            this.state.catStatusFilter,
            this.state.catInstructionTypeFilter
        ).then(
            res => {
                if (res.success) {
                    if (res.payload === undefined && stringFlag !== "FUNCTION") {
                        this.growl.show({
                            severity: 'info', summary: 'Info.',
                            detail: "No hay datos"
                        });
                    }
                    this.setState({
                        custodyInstructions: res.payload,
                    })
                } else {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: res.message
                    });
                }
                this.setState({
                    isLoading: false
                })
            }
        )
    }

    onChangeFilter(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,})
    }


    selectRowInstruction(event) {
        this.setState({
            selectedInstruction: event.value
        })
    }

    clearFilters() {
        this.setState({
            folioFilter: '',
            ptmFilter: [],
            pttFilter: [],
            catStatusFilter: [],
            catInstructionTypeFilter: [],
        })
    }

    exportSelection() {
        switch (this.state.typeDocument) {
            case "CSV":
                if (this.state.custodyInstructions === undefined || this.state.custodyInstructions.length === 0) {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'No hay datos a exportar.'
                    });
                } else {
                    this.loading();

                    this.custodyTitlesService.getCSV().then(resp => {
                        this.setState({
                            isLoading: false,
                        });
                    });
                }
                break;
            default:
                break;
        }
    }

    actionsTemplate(rowData, column) {
        let rowStatus = rowData.status.toUpperCase();

        if (!(rowData.instructionMode === "Premio" && rowData.maturity)) {
            if (rowStatus.toUpperCase() === INSTRUCCION_CREADA) {
                return <div>
                    <Button type="button" label={"Liquidar"}
                            onClick={() => this.actionUpdateStatus(rowData, "settle")}
                            style={{marginBottom: '.5em'}}/><br/>
                </div>
            }
        }
    }

    errorTemplate(rowData, column) {
        if (rowData.status.startsWith("Error")) {
            return (
                <div>Error &nbsp; &nbsp;&nbsp; &nbsp;
                    <Button icon="pi pi-bell" className="p-button-rounded p-button-secondary" tooltip={rowData.status}/>
                </div>);
        } else if (rowData.trustMessage !== undefined && rowData.trustMessage !== null && rowData.trustMessage !== '') {
            return (
                <div>rowData.status &nbsp; &nbsp;&nbsp; &nbsp;
                    <Button icon="pi pi-bell" className="p-button-rounded p-button-secondary"
                            tooltip={rowData.trustMessage}/>
                </div>);
        } else {
            return (<div> {rowData.status} </div>);
        }

    }

    actionUpdateStatus(rowData, action) {
        this.loading();

        if (action === "settle") {
            this.custodyTitlesService.settleInstruction(rowData.loanId).then(response => {
                if (response.success) {
                    this.growl.show({
                        severity: 'success', summary: 'Éxito.',
                        detail: 'Se ha actualizado correctamente su solicitud.'
                    });
                    this.searchInstructionsCustody("FUNCTION");
                } else {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: response.message
                    });
                }
            })
        } else {
            if (action === "confirmSettle") {
                this.custodyTitlesService.confirmSettleInstruction(rowData.loanId).then(response => {
                    if (response.success) {
                        this.growl.show({
                            severity: 'success', summary: 'Éxito.',
                            detail: 'Se ha actualizado correctamente su solicitud.'
                        });
                        this.searchInstructionsCustody("FUNCTION");
                    } else {
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: response.message
                        });
                    }
                })
            } else {
                this.custodyTitlesService.cancelInstruction(rowData.loanId).then(response => {
                    if (response.success) {
                        this.growl.show({
                            severity: 'success', summary: 'Éxito.',
                            detail: 'Se ha actualizado correctamente su solicitud.'
                        });
                        this.searchInstructionsCustody("FUNCTION");
                    } else {
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: response.message
                        });
                    }
                })
            }
        }
    }

    rewardBackGroundTemplate(rowData) {
        return {"p-highlight": rowData.instructionMode === "Premio"};
    }

    rewardTitlesBody(rowData) {
        let decimalScale = rowData.instructionMode === "Premio" ? 2 : 0;
        let fixedDecimalScale = rowData.instructionMode === "Premio";
        return <NumberFormat
            value={Number(rowData.amount)}
            displayType={'text'}
            decimalScale={decimalScale}
            fixedDecimalScale={fixedDecimalScale}
            thousandSeparator={true}
            renderText={
                value =>
                    <div style={{textAlign: "right"}}>{value}</div>
            }/>;
    }

    render() {
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Usted está seguro de continuar descargando la información solicitada?"
                                           action={this.exportSelection}/>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            catInstructionType, catStatus, custodyInstructions,
            statusContingencyFilter, pttFilter, ptmFilter, catInstructionTypeFilter,
            folioFilter, catStatusFilter, selectedInstruction, exportOptions, catLender, catBorrower
        } = this.state;

        return (
            <ContingencyTrustBbvaView
                messagesGrowl={messagesGrowl}
                catInstructionType={catInstructionType}
                catStatus={catStatus}
                custodyInstructions={custodyInstructions}
                catLender={catLender}
                catBorrower={catBorrower}
                folioFilter={folioFilter}
                statusContingencyFilter={statusContingencyFilter}
                pttFilter={pttFilter}
                ptmFilter={ptmFilter}
                catInstructionTypeFilter={catInstructionTypeFilter}
                catStatusFilter={catStatusFilter}
                selectedInstruction={selectedInstruction}
                exportOptions={exportOptions}
                confMsg={confMsg}

                isLoading={this.state.isLoading}
                searchContingency={this.searchInstructionsCustody}
                onChangeFilter={this.onChangeFilter}
                clearFilters={this.clearFilters}
                selectRowInstruction={this.selectRowInstruction}
                exportSelection={this.exportSelection}
                actionsTemplate={this.actionsTemplate}
                errorTemplate={this.errorTemplate}
                actionUpdateStatus={this.actionUpdateStatus}

                rewardBackGroundTemplate={this.rewardBackGroundTemplate}
                rewardTitlesBody={this.rewardTitlesBody}
            />)
    }
};